export default __webpack_public_path__ + "static/media/refreshIcon.3a3757d7.svg";